/*
 *
 *  sagas
 *
 */

import { call, take, put, race, select, all, delay } from "redux-saga/effects"

import {
  LOAD_RECORD,
  LOAD_RECORDS,
  CREATE_RECORD,
  UPDATE_RECORD,
  UPDATE_CLIENT_RECORD,
  DELETE_RECORD,
  LOAD_RECORDS_META_DATA,
  UPDATE_STATUS,
  LEAD_STATUS,
  LOAD_RECORD_CLIENT_DETAILS,
  LOAD_CLIENT_RECORD,
  LOAD_RECORD_CLIENT_PROFILE_BY_ID,
  DELETE_CLIENT_RECORD,
  UPDATE_CLIENT_PROFILE_RECORD,
  LOAD_CLIENT_QUESTIONS_LIST,
  ADD_CLIENT_QUESTIONS_LIST,
  LOAD_CLIENT_DETAILS_QUESTIONS_LIST,
  NEW_LEAD_CREATION,
  ADD_CLIENT_COMPLETE,
  ADD_CLIENT_APPEARANCE,
  UPDATE_CLIENT_TYPE,
  // CREATE_RECORD_SUCCESS,
  // CREATE_RECORD_ERROR,
  UPDATE_ENGAGEMENT,
  UPDATE_HIGH_GOOD
} from "./constants"

import {
  loadRecords as loadRecordsAction,
  loadRecordsSuccess,
  loadRecordsError,
  loadRecordSuccess,
  loadRecordError,
  // createRecord,
  loadRecordClientDetails as loadRecordClientDetailsAction,
  loadRecordClientProfileById as loadRecordClientProfileByIdAction,
  loadRecordClientDetailsSuccess,
  loadRecordClientDetailsError,
  loadRecordClientProfileByIdSuccess,
  loadRecordClientProfileByIdError,
  createRecordSuccess,
  createRecordError,
  updateRecordSuccess,
  updateRecordError,
  deleteRecordSuccess,
  deleteRecordError,
  updateClientRecordSuccess,
  updateClientRecordError,
  deleteClientRecordSuccess,
  deleteClientRecordError,
  loadRecordsCacheHit,
  loadRecordsMetaData as loadRecordsMetaDataAction,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  updateClientStatusSuccess,
  updateClientStatusError,
  updateStatusSuccess,
  updateStatusError,
  leadStatusSuccess,
  leadStatusError,
  // loadClientRecordSuccess,
  updateClientProfileRecordSuccess,
  updateClientProfileRecordError,
  loadClientQuestionList,
  loadClientQuestionListSuccess,
  loadClientQuestionListError,
  createClientQuestionList,
  createClientQuestionListError,
  loadClientDetailsQuestionsList,
  loadClientDetailsQuestionsListSuccess,
  loadClientDetailsQuestionsListError,
  createNewLeadSuccess,
  createNewLeadError,
  addClientCompleteError,
  addClientAppearanceError,
  updateClientTypeSuccess,
  updateClientTypeError,
  updateEngagementSuccess,
  updateEngagementError,
  updateHighGoodSuccess,
  updateHighGoodError
} from "./actions"

import {
  loadRecords,
  loadRecordsMetaData,
  loadRecord,
  loadRecordClientDetails,
  loadRecordClientProfileById,
  createRecord,
  updateRecord,
  deleteRecord,
  updateClientRecord,
  updateClientStatus,
  deleteClientRecord,
  updateStatus,
  loadClientRecord,
  leadStatus,
  updateClientProfileRecord,
  loadClientQuestionDetails,
  createClientQuestionDetails,
  loadClientDetailsQuestions,
  createNewLeadDetails,
  clientCompleteApi,
  clientAppearanceApi,
  updateClientTypeAPI,
  updateEngagementAPI,
  updateHighGoodAPI
} from "./remotes"

import { selectRecords, selectUpdateTimestamp } from "./selectors"

// import { selectSession } from "../session/selectors"
// import { roleIds } from "../../helpers/tools"

// function* loadRecordsSaga() {
//   while (true) {
//     // eslint-disable-line no-constant-condition
//     const load = yield race({
//       explicitLoad: take(LOAD_RECORDS),
//     })

//     const { explicitLoad } = load
//     const { invalidateCache, filter } = explicitLoad || {}
//     const lastLoad = yield select(selectUpdateTimestamp())
//     const currentTimestamp = Math.floor(Date.now() / 1000)
//     const VALID_CACHE_DIFF = -30
//     yield put(loadRecordsMetaDataAction()) // Calling Dropdown API's

//     if (explicitLoad) {
//       if (
//         !invalidateCache &&
//         lastLoad &&
//         lastLoad - currentTimestamp > VALID_CACHE_DIFF
//       ) {
//         yield put(loadRecordsCacheHit())
//       } else {
//         try {
//           const result = yield call(loadRecords, filter)

//           if (result) {
//             yield put(loadRecordsSuccess(result.data))
//           } else {
//             yield put(loadRecordsError("Fetch Records Failed"))
//           }
//         } catch (error) {
//           yield put(
//             loadRecordsError(
//               (error && error.response && error.response.message) ||
//               "Fetch Records Failed"
//             )
//           )
//         }
//       }
//     }
//   }
// }

function* loadRecordsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_RECORDS),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadRecordsMetaDataAction(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadRecords, id)

        if (result) {
          yield put(loadRecordsSuccess(result.data))
        } else {
          yield put(loadRecordsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadRecordsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const loadRequest = yield race({
      request: take(LOAD_RECORD),
    })
    const { request } = loadRequest

    if (request) {
      const { id } = request
      try {
        const record = yield call(loadRecord, id)

        let recordsMetaData = {}
        if (record) {
          // Delays the dispatch of loadRecordSuccess untill the store is populated with an initial list of records.
          while (true) {
            // eslint-disable-line no-constant-condition
            const recordsInStore = yield select(selectRecords())
            if (recordsInStore && recordsInStore.length > 0) {
              break
            }
            yield delay(500)
          }
          yield put(loadRecordSuccess(record, recordsMetaData))
        } else {
          yield put(loadRecordError("Fetch Record Failed"))
        }
      } catch (error) {
        yield put(
          loadRecordError(
            (error && error.response && error.response.message) ||
              "Fetch Record Failed"
          )
        )
      }
    }
  }
}

function* loadRecordClientDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_RECORD_CLIENT_DETAILS),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadRecordClientDetailsAction(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadRecordClientDetails, id)

        if (result) {
          yield put(loadRecordClientDetailsSuccess(result.data))
        } else {
          yield put(loadRecordClientDetailsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadRecordClientDetailsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadRecordClientDetailsByIdActionsSaga() {
  while (true) {
    try {
      const load = yield race({
        explicitLoad: take(LOAD_RECORD_CLIENT_PROFILE_BY_ID),
      })
      const { explicitLoad } = load
      const { client } = explicitLoad || {}
      yield put(loadRecordClientProfileByIdAction(explicitLoad.id)) // Calling Dropdown API's

      const result = yield call(loadRecordClientProfileById, client)
      if (result) {
        yield put(loadRecordClientProfileByIdSuccess(result.data))
      } else {
        yield put(loadRecordClientProfileByIdError("Fetch Records Failed"))
      }
    } catch (error) {
      yield put(
        loadRecordClientProfileByIdError(
          (error && error.response && error.response.message) ||
            "Fetch Records Failed"
        )
      )
    }
  }
}

function* loadClientRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_CLIENT_RECORD),
    })

    const { explicitLoad } = load

    const { invalidateCache, id } = explicitLoad || {}
    const lastLoad = yield select(selectUpdateTimestamp())
    const currentTimestamp = Math.floor(Date.now() / 1000)
    const VALID_CACHE_DIFF = -30
    yield put(loadClientRecord(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      if (
        !invalidateCache &&
        lastLoad &&
        lastLoad - currentTimestamp > VALID_CACHE_DIFF
      ) {
        yield put(loadRecordsCacheHit())
      } else {
        try {
          const result = yield call(loadClientRecord, id)

          if (result) {
            yield put(loadRecordClientDetailsSuccess(result.data))
          } else {
            yield put(loadRecordClientDetailsError("Fetch Records Failed"))
          }
        } catch (error) {
          yield put(
            loadRecordClientDetailsError(
              (error && error.response && error.response.message) ||
                "Fetch Records Failed"
            )
          )
        }
      }
    }
  }
}

function* createRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(CREATE_RECORD),
    })
    const { profileData, record, setSubmitting } = create || {}
    console.log("records-create", profileData, setSubmitting)
    if (create) {
      console.log("records", profileData)
      // yield call(setSubmitting, true)
      try {
        yield call(createRecord, profileData, record)
        // yield delay(1000)
        console.log("create records", profileData)
        var successVal = createRecordSuccess(
          profileData,
          [],
          "Client Details Created Successfully"
        )
        yield put(successVal)
      } catch (error) {
        yield put(
          createRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        //   yield call(setSubmitting, false)
      }
    }
  }
}

function* editClientProfileRecordSaga() {
  console.log("&&&&&&&&&&&&&&&&&&&&&& --> client profille callled")

  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(UPDATE_CLIENT_PROFILE_RECORD),
    })

    console.log("FFFF->", edit)

    const { record } = edit || {}

    if (edit) {
      console.log("edit client profile")
      //yield call(edit.setSubmitting.setSubmitting, true)
      //yield call(setSubmitting, true)

      try {
        yield call(updateClientProfileRecord, record)
        yield delay(1000)

        yield put(
          updateClientProfileRecordSuccess(
            record,
            "Client Profile Updated Successfully"
            //success
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateClientProfileRecordError(
            (error && error.response && error.response.message) ||
              "Client Profile Update Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* editRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(UPDATE_RECORD),
    })

    const { record, setSubmitting, redirect } = edit || {}

    if (edit) {
      yield call(edit.setSubmitting.setSubmitting, true)

      try {
        yield call(updateRecord, record)
        yield delay(1000)
        yield put(updateRecordSuccess(record, "Record Updated Successfully"))
        yield call(redirect)
      } catch (error) {
        yield put(
          updateRecordError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      } finally {
        yield call(setSubmitting, false)
      }
    }
  }
}

function* editClientRecordSaga() {
  console.log("FFFF &&& Lokesh Func ->")

  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(UPDATE_CLIENT_RECORD),
    })
    console.log("FFFF &&& Lokesh Func ->", edit)

    const { profileData, record, redirect } = edit || {}
    console.log("records-updated", record, profileData, redirect)

    if (edit) {
      // yield call(edit.setSubmitting.setSubmitting, true)

      try {
        yield call(updateClientRecord, profileData)
        yield delay(1000)
        yield put(
          updateClientRecordSuccess(
            profileData,
            [],
            "Record Updated Successfully"
          )
        )
        // yield put(loadRecordClientDetailsAction(profileData._id))
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateClientRecordError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      } finally {
        //   yield call(setSubmitting, false)
      }
    }
  }
}
function* deleteRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { del } = yield race({
      del: take(DELETE_RECORD),
    })
    const { id, setSubmitting, redirect } = del || {}
    if (del) {
      yield call(setSubmitting, true)

      try {
        yield call(deleteRecord, id)
        yield delay(1000)
        yield put(deleteRecordSuccess(id, "Record Deleted Successfully"))
        yield call(redirect)
      } catch (error) {
        yield put(
          deleteRecordError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        yield call(setSubmitting, false)
      }
    }
  }
}

function* deleteClientRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { del } = yield race({
      del: take(DELETE_CLIENT_RECORD),
    })
    const { clientRemoveId } = del || {}
    if (del) {
      // yield call(setSubmitting, true)

      try {
        yield call(deleteClientRecord, clientRemoveId)
        yield delay(1000)
        yield put(
          deleteClientRecordSuccess(
            clientRemoveId,
            "Record Deleted Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          deleteClientRecordError(
            (error && error.response && error.response.message) || ""
          )
        )
      } finally {
        //   yield call(setSubmitting, false)
      }
    }
  }
}

//Client Questions list
function* loadClientQuestionsListSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_CLIENT_QUESTIONS_LIST),
    })

    const { explicitLoad } = load

    // const { id } = explicitLoad || {}
    yield put(loadClientQuestionList(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadClientQuestionDetails)

        if (result) {
          yield put(loadClientQuestionListSuccess(result.data))
        } else {
          yield put(loadClientQuestionListError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadClientQuestionListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

//Client Questions list
function* loadClientDetailsQuestionsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_CLIENT_DETAILS_QUESTIONS_LIST),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadClientDetailsQuestionsList(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadClientDetailsQuestions, id)

        if (result) {
          yield put(loadClientDetailsQuestionsListSuccess(result.data))
        } else {
          yield put(loadClientDetailsQuestionsListError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadClientDetailsQuestionsListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* createClientQuestionDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_CLIENT_QUESTIONS_LIST),
    })
    const { questionsList } = create || {}

    if (create) {
      try {
        yield call(createClientQuestionDetails, questionsList)
        var successVal = createClientQuestionList(
          questionsList,
          [],
          "Client Questions Created Successfully"
        )
        yield put(successVal)
      } catch (error) {
        yield put(
          createClientQuestionListError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        //   yield call(setSubmitting, false)
      }
    }
  }
}

//New lead clone creations

function* createNewLeadDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(NEW_LEAD_CREATION),
    })
    const { newLead } = create || {}

    if (create) {
      try {
        yield call(createNewLeadDetails, newLead)
        var successVal = createNewLeadSuccess(
          newLead,
          "Records Created Successfully"
        )
        yield put(successVal)
      } catch (error) {
        yield put(
          createNewLeadError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        //   yield call(setSubmitting, false)
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      // let sessionDetails
      // while (true) {
      //   // eslint-disable-line no-constant-condition
      //   const sessionInStore = yield select(selectSession())

      //   const { user = {} } = sessionInStore
      //   if (user && Object.keys(user).length > 0) {
      //     sessionDetails = sessionInStore
      //     break
      //   }
      //   yield delay(500)
      // }

      // let company
      // let branch
      // if (
      //   sessionDetails &&
      //   sessionDetails.user &&
      //   roleIds.includes(sessionDetails.user.roleId)
      // ) {
      //   // company = yield call(loadRecordsMetaData, "company", "post")
      //   branch = yield call(loadRecordsMetaData, "branch", "post")
      // } else {
      //   // company =
      //   //   (sessionDetails &&
      //   //     sessionDetails.user &&
      //   //     sessionDetails.user.company &&
      //   //     sessionDetails.user.company.length > 0 &&
      //   //     sessionDetails.user.company.map((_) => _.detail)) ||
      //   //   []
      //   branch =
      //     (sessionDetails &&
      //       sessionDetails.user &&
      //       sessionDetails.user.branch &&
      //       sessionDetails.user.branch.length > 0 &&
      //       sessionDetails.user.branch.map((_) => _.detail)) ||
      //     []
      // }
      const clientProfile = yield call(
        loadRecordsMetaData,
        "client_profile",
        "post"
      )
      const country = yield call(loadRecordsMetaData, "country", "post")
      const state = yield call(loadRecordsMetaData, "state", "post")
      const city = yield call(loadRecordsMetaData, "city", "post")

      let recordsMetaData = {
        // companyOptions:
        //   (company &&
        //     company.data &&
        //     company.data.length > 0 &&
        //     company.data.filter(_=> _.status === 1).map((c) =>
        //       Object.assign({}, { label: c.name, value: c._id })
        //     )) ||
        //   (company &&
        //     company.length > 0 &&
        //     company.map((c) =>
        //       Object.assign({}, { label: c.name, value: c._id })
        //     )) ||
        //   [],
        // branchOptions:
        //   (branch &&
        //     branch.data &&
        //     branch.data.length > 0 &&
        //     branch.data.filter(_=> _.status === 1).map((c) =>
        //       Object.assign(
        //         {},
        //         { label: c.name, value: c._id, companyId: c.companyId }
        //       )
        //     )) ||
        //   (branch &&
        //     branch.length > 0 &&
        //     branch.map((c) =>
        //       Object.assign(
        //         {},
        //         { label: c.name, value: c._id, companyId: c.companyId }
        //       )
        //     )) ||
        //   [],
        countryOptions:
          (country &&
            country.data &&
            country.data.length > 0 &&
            country.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.name,
                    value: c._id,
                    states: c.states,
                    shortName: c.shortName,
                  }
                )
              )) ||
          [],
        stateOptions:
          (state &&
            state.data &&
            state.data.length > 0 &&
            state.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.name, value: c._id })
              )) ||
          [],
        cityOptions:
          (city &&
            city.data &&
            city.data.length > 0 &&
            city.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.name,
                    value: c._id,
                    sourceId: c.sourceId,
                    stateId: c.state && c.state._id,
                  }
                )
              )) ||
          [],
        clientProfileOptions:
          (clientProfile &&
            clientProfile.data &&
            clientProfile.data.length > 0 &&
            clientProfile.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.clientProfile, value: c._id })
              )) ||
          [],
      }

      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

function* updateClientStatusSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { update } = yield race({
      update: take(UPDATE_STATUS),
    })
    const { profileData = {}, record = {}, setSubmitting, redirect } = update
    yield call(setSubmitting, true)

    try {
      const result = yield call(updateClientStatus, record, profileData)
      if (result) {
        yield put(
          updateClientStatusSuccess(
            record,
            profileData,
            "Status Updated Successfully"
          )
        )
        yield call(redirect)
      } else {
        yield put(updateClientStatusError("Update Status Records Failed"))
      }
    } catch (error) {
      yield put(
        updateClientStatusError(
          (error && error.response && error.response.message) ||
            "Update Status Records Failed"
        )
      )
    } finally {
      yield call(setSubmitting, false)
    }
  }
}
function* updateStatusSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { update } = yield race({
      update: take(UPDATE_STATUS),
    })
    const { record = {}, setSubmitting, redirect } = update
    yield call(setSubmitting, true)

    try {
      const result = yield call(updateStatus, record)
      if (result) {
        yield put(updateStatusSuccess(record, "Status Updated Successfully"))
        yield call(redirect)
      } else {
        yield put(updateStatusError("Update Status Records Failed"))
      }
    } catch (error) {
      yield put(
        updateStatusError(
          (error && error.response && error.response.message) ||
            "Update Status Records Failed"
        )
      )
    } finally {
      yield call(setSubmitting, false)
    }
  }
}

function* leadStatusSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { lead } = yield race({
      lead: take(LEAD_STATUS),
    })
    const { record = {}, setSubmitting, redirect } = lead
    yield call(setSubmitting, true)

    try {
      const result = yield call(leadStatus, record)
      if (result) {
        yield put(leadStatusSuccess(record, "Status Updated Successfully"))
        yield call(redirect)
        yield put(loadRecordsAction({ status: "active" }, true))
      } else {
        yield put(leadStatusError("Lead Status Records Failed"))
      }
    } catch (error) {
      yield put(
        leadStatusError(
          (error && error.response && error.response.message) ||
            "Lead Status Records Failed"
        )
      )
    } finally {
      yield call(setSubmitting, false)
    }
  }
}

function* clientCompleteSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_CLIENT_COMPLETE),
    })
    const { client_complete} = create || {}

    if (create) {
      try {
        yield call(clientCompleteApi,client_complete)
        
       
      } catch (error) {
        yield put(
          addClientCompleteError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        //   yield call(setSubmitting, false)
      }
    }
  }
}

//addClientAppearanceSaga

function* addClientAppearanceSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_CLIENT_APPEARANCE),
    })
    const {clientAppearance_details} = create || {}

    if (create) {
      try {
        yield call(clientAppearanceApi,clientAppearance_details)
        
       
      } catch (error) {
        yield put(
          addClientAppearanceError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        //   yield call(setSubmitting, false)
      }
    }
  }
}

function* updateClientTypeSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_CLIENT_TYPE),
    })
    const {clientType } = create || {}
    if (create) {
     
      try {
        yield call(
          updateClientTypeAPI,
          clientType
        )
          yield put(updateClientTypeSuccess(clientType))
        
      } catch (error) {
        yield put(
          updateClientTypeError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      }
    }
  }
}


function* updateEngagementSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_ENGAGEMENT),
    })
    const {engage_details} = create || {}
    if (create) {
     
      try {
        yield call(
          updateEngagementAPI,
          engage_details
        )
          yield put(updateEngagementSuccess(engage_details))
        
      } catch (error) {
        yield put(
          updateEngagementError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      }
    }
  }
}
//
//updateHighGood
function* updateHighGoodSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_HIGH_GOOD),
    })
    const {highGood_details} = create || {}
    if (create) {
     
      try {
        yield call(
          updateHighGoodAPI,
          highGood_details
        )
          yield put(updateHighGoodSuccess(highGood_details))
        
      } catch (error) {
        yield put(
          updateHighGoodError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      }
    }
  }
}
export default function* recordsSaga() {
  yield all([
    loadRecordSaga(),
    loadRecordsSaga(),
    loadRecordClientDetailsSaga(),
    loadRecordClientDetailsByIdActionsSaga(),
    createRecordSaga(),
    editRecordSaga(),
    editClientProfileRecordSaga(),
    deleteClientRecordSaga(),
    editClientRecordSaga(),
    updateClientStatusSaga(),
    deleteRecordSaga(),
    loadRecordsMetaDataSaga(),
    updateStatusSaga(),
    leadStatusSaga(),
    loadClientRecordSaga(),
    createClientQuestionDetailsSaga(),
    loadClientQuestionsListSaga(),
    loadClientDetailsQuestionsSaga(),
    createNewLeadDetailsSaga(),
    clientCompleteSaga(),
    addClientAppearanceSaga(),
    updateClientTypeSaga(),
    updateEngagementSaga(),
    updateHighGoodSaga()
  ])
}
